import { SelectMeasuringPoints } from "./features/form-fields/components/field-select-measuring-points";

export const FIELDS = {
  SelectMeasuringPoints,
};
